module.exports = __webpack_public_path__ + "static/media/iconfinder_Messages-Android-R_67502.4dd9ec7c.png";